import { createAction } from 'redux-actions';
import { reduxKey } from '../../constants';

export const logoutSession = createAction(
  `${reduxKey}.LOGOUT_SESSION`,
  (sessionId: string) => ({ sessionId })
);

export const logoutSessionSuccess = createAction(
  `${reduxKey}.LOGOUT_SESSION_SUCCESS`,
  (sessionId: string) => ({ sessionId })
);

export const logoutSessionFailure = createAction(
  `${reduxKey}.LOGOUT_SESSION_FAILURE`,
  (sessionId: string, errorMessage: string) => ({ sessionId, errorMessage })
);
